import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('CAN_REVIEW_LAB_RESEARCH_ORDER')